export default "__VITE_ASSET__BdZoJ$2f__"